"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/override.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Foverride.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideToJSON = exports.overrideFromJSON = exports.Override = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
var Override;
(function (Override) {
    Override["INVALID_OVERRIDE"] = "INVALID_OVERRIDE";
    /**
     * DEBIT_FUNDING_LOCK - Debit card funding subtype for DISABLE_FUNDING
     */
    Override["DEBIT_FUNDING_LOCK"] = "DEBIT_FUNDING_LOCK";
    /**
     * CASH_DEPOSIT_FUNDING_LOCK - Cash deposit funding subtype for DISABLE_FUNDING
     */
    Override["CASH_DEPOSIT_FUNDING_LOCK"] = "CASH_DEPOSIT_FUNDING_LOCK";
    /**
     * ACH_FUNDING_LOCK - ACH funding subtype for DISABLE_FUNDING
     */
    Override["ACH_FUNDING_LOCK"] = "ACH_FUNDING_LOCK";
    /**
     * TRANSACTION_LOCK - All spending and withdrawal activity is limited to $0
     */
    Override["TRANSACTION_LOCK"] = "TRANSACTION_LOCK";
    /**
     * RISK_SUSPENSION - All transactions, except for Step card transactions, are limited to $0
     */
    Override["RISK_SUSPENSION"] = "RISK_SUSPENSION";
    /**
     * STEP_CARD_LOCK - Step card transactions are limited to $0
     */
    Override["STEP_CARD_LOCK"] = "STEP_CARD_LOCK";
    /**
     * INCREASED_SPENDING - Increased Step card spending limits to $3000
     */
    Override["INCREASED_SPENDING"] = "INCREASED_SPENDING";
    /**
     * WITHDRAWAL_ONLY - Limit the user to withdrawals only
     */
    Override["WITHDRAWAL_ONLY"] = "WITHDRAWAL_ONLY";
    /**
     * FLEX_CARD_LOCK - All Flex card transactions are limited to $0
     */
    Override["FLEX_CARD_LOCK"] = "FLEX_CARD_LOCK";
    /**
     * INCREASED_INSTANT_TRANSFER_TIER1 - Instant Transfer Limit Increase
     */
    Override["INCREASED_INSTANT_TRANSFER_TIER1"] = "INCREASED_INSTANT_TRANSFER_TIER1";
    Override["INCREASED_INSTANT_TRANSFER_TIER2"] = "INCREASED_INSTANT_TRANSFER_TIER2";
    Override["INCREASED_INSTANT_TRANSFER_TIER3"] = "INCREASED_INSTANT_TRANSFER_TIER3";
    /**
     * CHECK_DEPOSIT_FUNDING_LOCK - Check Deposit Funding Lock to disable users from depositing checks
     */
    Override["CHECK_DEPOSIT_FUNDING_LOCK"] = "CHECK_DEPOSIT_FUNDING_LOCK";
    Override["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Override || (exports.Override = Override = {}));
function overrideFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_OVERRIDE':
            return Override.INVALID_OVERRIDE;
        case 5:
        case 'DEBIT_FUNDING_LOCK':
            return Override.DEBIT_FUNDING_LOCK;
        case 6:
        case 'CASH_DEPOSIT_FUNDING_LOCK':
            return Override.CASH_DEPOSIT_FUNDING_LOCK;
        case 7:
        case 'ACH_FUNDING_LOCK':
            return Override.ACH_FUNDING_LOCK;
        case 2:
        case 'TRANSACTION_LOCK':
            return Override.TRANSACTION_LOCK;
        case 3:
        case 'RISK_SUSPENSION':
            return Override.RISK_SUSPENSION;
        case 4:
        case 'STEP_CARD_LOCK':
            return Override.STEP_CARD_LOCK;
        case 8:
        case 'INCREASED_SPENDING':
            return Override.INCREASED_SPENDING;
        case 9:
        case 'WITHDRAWAL_ONLY':
            return Override.WITHDRAWAL_ONLY;
        case 10:
        case 'FLEX_CARD_LOCK':
            return Override.FLEX_CARD_LOCK;
        case 20:
        case 'INCREASED_INSTANT_TRANSFER_TIER1':
            return Override.INCREASED_INSTANT_TRANSFER_TIER1;
        case 21:
        case 'INCREASED_INSTANT_TRANSFER_TIER2':
            return Override.INCREASED_INSTANT_TRANSFER_TIER2;
        case 22:
        case 'INCREASED_INSTANT_TRANSFER_TIER3':
            return Override.INCREASED_INSTANT_TRANSFER_TIER3;
        case 23:
        case 'CHECK_DEPOSIT_FUNDING_LOCK':
            return Override.CHECK_DEPOSIT_FUNDING_LOCK;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Override.UNRECOGNIZED;
    }
}
exports.overrideFromJSON = overrideFromJSON;
function overrideToJSON(object) {
    switch (object) {
        case Override.INVALID_OVERRIDE:
            return 'INVALID_OVERRIDE';
        case Override.DEBIT_FUNDING_LOCK:
            return 'DEBIT_FUNDING_LOCK';
        case Override.CASH_DEPOSIT_FUNDING_LOCK:
            return 'CASH_DEPOSIT_FUNDING_LOCK';
        case Override.ACH_FUNDING_LOCK:
            return 'ACH_FUNDING_LOCK';
        case Override.TRANSACTION_LOCK:
            return 'TRANSACTION_LOCK';
        case Override.RISK_SUSPENSION:
            return 'RISK_SUSPENSION';
        case Override.STEP_CARD_LOCK:
            return 'STEP_CARD_LOCK';
        case Override.INCREASED_SPENDING:
            return 'INCREASED_SPENDING';
        case Override.WITHDRAWAL_ONLY:
            return 'WITHDRAWAL_ONLY';
        case Override.FLEX_CARD_LOCK:
            return 'FLEX_CARD_LOCK';
        case Override.INCREASED_INSTANT_TRANSFER_TIER1:
            return 'INCREASED_INSTANT_TRANSFER_TIER1';
        case Override.INCREASED_INSTANT_TRANSFER_TIER2:
            return 'INCREASED_INSTANT_TRANSFER_TIER2';
        case Override.INCREASED_INSTANT_TRANSFER_TIER3:
            return 'INCREASED_INSTANT_TRANSFER_TIER3';
        case Override.CHECK_DEPOSIT_FUNDING_LOCK:
            return 'CHECK_DEPOSIT_FUNDING_LOCK';
        case Override.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.overrideToJSON = overrideToJSON;
//# sourceMappingURL=override.js.map